export default "__VITE_ASSET__DZFOUWCV__"